var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"16px"}},[_c('div',{staticClass:"weui-mask_transparent"}),_c('div',{staticClass:"toast_wrap"},[_c('span',{staticClass:"toast"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }